export const categories = [
  {
    name: "Shoes",
    description: "Sneakers, dunks & more",
    link: "https://kaspreadsheet.com/category-911-Shoes.html",
    tag: "Hot",
    image: "https://readdy.ai/api/search-image?query=Close%20up%20detail%20shot%20of%20premium%20white%20leather%20sneakers%20on%20polished%20concrete%20floor%20with%20natural%20window%20light%20casting%20soft%20shadows%20editorial%20footwear%20photography%20high%20contrast%20clean%20modern%20aesthetic%20professional%20product%20styling&width=600&height=400&seq=cat-shoes-v2&orientation=landscape"
  },
  {
    name: "Hoodies/Sweaters",
    description: "Essentials, streetwear",
    link: "https://kaspreadsheet.com/search-912/name/Shoes.html",
    tag: "Trending",
    image: "https://readdy.ai/api/search-image?query=Oversized%20grey%20hoodie%20draped%20casually%20over%20a%20vintage%20wooden%20chair%20in%20a%20sunlit%20loft%20apartment%20golden%20hour%20warm%20light%20streaming%20through%20large%20windows%20cozy%20urban%20lifestyle%20photography%20textured%20fabric%20details&width=600&height=400&seq=cat-hoodies-v2&orientation=landscape"
  },
  {
    name: "T-Shirts",
    description: "Graphic & basic tees",
    link: "https://kaspreadsheet.com/search-913/name/Shoes.html",
    tag: "New",
    image: "https://readdy.ai/api/search-image?query=Stack%20of%20vibrant%20colored%20cotton%20t-shirts%20neatly%20folded%20on%20a%20white%20modern%20shelf%20in%20a%20bright%20boutique%20store%20soft%20diffused%20daylight%20fashion%20retail%20photography%20clean%20minimal%20commercial%20style&width=600&height=400&seq=cat-tshirts-v2&orientation=landscape"
  },
  {
    name: "Jackets",
    description: "Bombers, puffers & coats",
    link: "https://kaspreadsheet.com/search-914/name/Shoes.html",
    tag: "Hot",
    image: "https://readdy.ai/api/search-image?query=Premium%20black%20leather%20biker%20jacket%20elegantly%20draped%20over%20an%20antique%20brass%20coat%20stand%20against%20exposed%20brick%20wall%20dramatic%20side%20lighting%20from%20nearby%20window%20luxury%20editorial%20fashion%20photography%20rich%20textures&width=600&height=400&seq=cat-jackets-v2&orientation=landscape"
  },
  {
    name: "Pants/Shorts",
    description: "Cargos, jeans & shorts",
    link: "https://kaspreadsheet.com/search-915/name/Shoes.html",
    tag: "",
    image: "https://readdy.ai/api/search-image?query=Stack%20of%20premium%20denim%20jeans%20in%20various%20washes%20piled%20artistically%20on%20rustic%20distressed%20wooden%20floor%20natural%20morning%20sunlight%20from%20skylight%20casual%20editorial%20fashion%20photography%20authentic%20raw%20texture&width=600&height=400&seq=cat-pants-v2&orientation=landscape"
  },
  {
    name: "Headwear",
    description: "Caps, beanies & hats",
    link: "https://kaspreadsheet.com/search-916/name/Shoes.html",
    tag: "",
    image: "https://readdy.ai/api/search-image?query=Collection%20of%20colorful%20baseball%20caps%20displayed%20on%20minimalist%20wall%20hooks%20inside%20a%20modern%20skate%20shop%20with%20industrial%20pipes%20and%20concrete%20walls%20cool%20ambient%20neon%20accent%20lighting%20streetwear%20culture%20photography&width=600&height=400&seq=cat-headwear-v2&orientation=landscape"
  },
  {
    name: "Sets",
    description: "Matching outfit combos",
    link: "https://kaspreadsheet.com/search-917/name/Shoes.html",
    tag: "New",
    image: "https://readdy.ai/api/search-image?query=Coordinated%20matching%20tracksuit%20set%20neatly%20laid%20out%20on%20a%20plush%20hotel%20bed%20with%20crisp%20white%20linens%20morning%20sunlight%20filtering%20through%20sheer%20curtains%20luxury%20resort%20lifestyle%20photography%20serene%20and%20elegant&width=600&height=400&seq=cat-sets-v2&orientation=landscape"
  },
  {
    name: "Underwear/Underpants",
    description: "Basics & essentials",
    link: "https://kaspreadsheet.com/search-918/name/Shoes.html",
    tag: "",
    image: "https://readdy.ai/api/search-image?query=Premium%20cotton%20boxer%20briefs%20neatly%20folded%20and%20arranged%20on%20a%20smooth%20grey%20marble%20countertop%20in%20a%20spa-like%20bathroom%20setting%20soft%20diffused%20overhead%20lighting%20luxury%20minimalist%20product%20photography%20clean%20sophisticated&width=600&height=400&seq=cat-underwear-v2&orientation=landscape"
  },
  {
    name: "Jersey",
    description: "Sports & team jerseys",
    link: "https://kaspreadsheet.com/search-919/name/Shoes.html",
    tag: "",
    image: "https://readdy.ai/api/search-image?query=Professional%20soccer%20jersey%20displayed%20on%20a%20mannequin%20inside%20a%20stadium%20locker%20room%20with%20dramatic%20overhead%20spotlight%20illumination%20dark%20moody%20background%20sports%20editorial%20photography%20athletic%20atmosphere%20bold%20contrast&width=600&height=400&seq=cat-jersey-v2&orientation=landscape"
  },
  {
    name: "Accessories",
    description: "Watches, jewelry & more",
    link: "https://kaspreadsheet.com/search-920/name/Shoes.html",
    tag: "Hot",
    image: "https://readdy.ai/api/search-image?query=Elegant%20wrist%20wearing%20a%20sleek%20silver%20watch%20and%20minimalist%20bracelet%20resting%20on%20a%20dark%20wooden%20table%20with%20a%20coffee%20cup%20nearby%20morning%20sunlight%20lifestyle%20close-up%20editorial%20photography%20warm%20inviting%20atmosphere&width=600&height=400&seq=cat-accessories-v2&orientation=landscape"
  },
  {
    name: "Bags",
    description: "Backpacks, totes & crossbody",
    link: "https://kaspreadsheet.com/search-921/name/Shoes.html",
    tag: "",
    image: "https://readdy.ai/api/search-image?query=Stylish%20leather%20backpack%20resting%20on%20a%20subway%20seat%20inside%20a%20modern%20metro%20train%20with%20blurred%20motion%20through%20windows%20urban%20commute%20lifestyle%20photography%20cool%20contemporary%20editorial%20style%20dynamic%20composition&width=600&height=400&seq=cat-bags-v2&orientation=landscape"
  },
  {
    name: "Belts",
    description: "Leather & designer belts",
    link: "https://kaspreadsheet.com/search-922/name/Shoes.html",
    tag: "",
    image: "https://readdy.ai/api/search-image?query=Three%20rolled%20genuine%20leather%20belts%20in%20brown%20black%20and%20tan%20displayed%20inside%20a%20glass%20boutique%20showcase%20with%20warm%20spotlight%20illumination%20luxury%20retail%20photography%20elegant%20ambient%20store%20atmosphere%20refined%20presentation&width=600&height=400&seq=cat-belts-v2&orientation=landscape"
  },
  {
    name: "Perfumes",
    description: "Designer fragrances",
    link: "https://kaspreadsheet.com/search-923/name/Shoes.html",
    tag: "New",
    image: "https://readdy.ai/api/search-image?query=Two%20elegant%20glass%20perfume%20bottles%20with%20golden%20accents%20reflected%20on%20a%20mirrored%20vanity%20tray%20with%20fresh%20rose%20petals%20scattered%20nearby%20soft%20glamorous%20dressing%20room%20lighting%20luxury%20cosmetic%20photography%20feminine%20aesthetic&width=600&height=400&seq=cat-perfumes-v2&orientation=landscape"
  },
  {
    name: "Other Stuff",
    description: "Miscellaneous finds",
    link: "https://kaspreadsheet.com/search-924/name/Shoes.html",
    tag: "",
    image: "https://readdy.ai/api/search-image?query=Various%20fashion%20and%20lifestyle%20items%20spilling%20out%20of%20a%20premium%20kraft%20paper%20shopping%20bag%20on%20a%20white%20desk%20unboxing%20flat%20lay%20concept%20bright%20overhead%20studio%20lighting%20commercial%20product%20photography%20clean%20crisp%20details&width=600&height=400&seq=cat-other-v2&orientation=landscape"
  }
];